var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_60",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m67.79,84.995v2.196c0,.512-.415.927-.927.927h-33.727c-.512,0-.927-.415-.927-.927v-2.196c.083-4.234.436-15.372,1.047-19.56.899-6.106,2.261-10.368,4.16-14.436,1.909-4.077,4.355-7.968,7.412-13.324l.704-1.223V14.864c0-.512.415-.927.927-.927h7.079c.512,0,.927.415.927.927v21.589l.704,1.223c3.058,5.355,5.504,9.247,7.412,13.324,1.899,4.068,3.261,8.33,4.16,14.436.612,4.188.964,15.325,1.047,19.56Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }